export default __webpack_public_path__ + "images/GJ.35e175f.png";